export default "__VITE_ASSET__cf179762__"